import SubdomainSite from "@/subdomains/SubdomainSite";
import config from "@/subdomains/configs/precast";

/** Precast page — precast.bizlem.com */
export default function PrecastPage() {
  return <SubdomainSite config={config} />;
}

export { config };
